import React from "react";
import removeImg from "assets/svgs/close.svg";
import { v4 } from "uuid";
import ImageUpdate from "./ImageUpdate";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { Controller } from "react-hook-form";
import ImageUpdateValue from "components/shared/ImageUpdateValue";

const SlidersArray = ({ sliders, setSliders }) => {
  const handleInputOnChange = (e, id) => {
    const { name, value } = e.target;

    const newSlidersArray = sliders?.map((slider) => {
      if (slider.id !== id) return slider;

      // make an object with locals inside the big one
      const inputName = name?.split(".")?.[0];
      const local = name?.split(".")?.[1];

      if (local) {
        return {
          ...slider,
          [inputName]: {
            ...slider?.[inputName],
            [local]: value,
          },
        };
      }

      return { ...slider, [name]: value };
    });

    setSliders(newSlidersArray);
  };

  const removeSlider = (sliderId) => {
    const newSliders = sliders?.filter((slider, index) => index !== sliderId);
    setSliders(() => newSliders);
  };

  const addSlider = () => {
    setSliders(() => [...(sliders || []), { id: v4(), image: "" }]);
  };

  return (
    <div className="form-group branches sliders">
      <Row>
        <Col lg={12}>
          {/* <h5>
            <FormattedMessage id={"sliders"} />
          </h5> */}
          <Row>
            {sliders?.map((slider, index) => {
              return (
                <Col xs="12" key={slider.id} className=" p-2 h-100">
                  <div className="add-multi-component">
                    {/* <button
                      type="button"
                      onClick={() => removeSlider(index)}
                      className="removeImg"
                    >
                      <img src={removeImg} alt="" />
                    </button> */}
                    <Row>
                      <Col xs={12} md="6">
                        <ImageUpdate
                          index={index}
                          item={slider}
                          sliders={sliders}
                          setSliders={setSliders}
                        />
                      </Col>
                      <Col xs="12" md="6">
                        <ImageUpdateValue
                          title="circleImage"
                          value={slider?.circleImage}
                          setValue={(value) =>
                            handleInputOnChange(
                              { target: { name: "circleImage", value } },
                              slider.id
                            )
                          }
                        />
                      </Col>
                      <Col lg={6} xs={12}>
                        <div className="form-group">
                          <h5>
                            <FormattedMessage id={"title"} /> ({" "}
                            <FormattedMessage id={"arabic-language"} /> )
                          </h5>
                          <input
                            type="text"
                            name="title.ar"
                            className="form-control form-outline"
                            onChange={(e) => handleInputOnChange(e, slider.id)}
                            value={slider?.title?.ar}
                          />
                        </div>
                      </Col>
                      <Col lg={6} xs={12}>
                        <div className="form-group">
                          <h5>
                            <FormattedMessage id={"title"} /> ({" "}
                            <FormattedMessage id={"english-language"} /> )
                          </h5>
                          <input
                            type="text"
                            name="title.en"
                            className="form-control form-outline"
                            onChange={(e) => handleInputOnChange(e, slider.id)}
                            value={slider?.title?.en}
                          />
                        </div>
                      </Col>
                      <Col xxl={6} xs={12}>
                        <div className="form-group">
                          <h5>
                            <FormattedMessage id={"description"} /> ({" "}
                            <FormattedMessage id={"arabic-language"} /> )
                          </h5>
                          <textarea
                            type="text"
                            name="description.ar"
                            className="form-control form-outline"
                            onChange={(e) => handleInputOnChange(e, slider.id)}
                            value={slider?.description?.ar}
                          />
                        </div>
                      </Col>
                      <Col xxl={6} xs={12}>
                        <div className="form-group">
                          <h5>
                            <FormattedMessage id={"description"} /> ({" "}
                            <FormattedMessage id={"english-language"} /> )
                          </h5>
                          <textarea
                            type="text"
                            name="description.en"
                            className="form-control form-outline"
                            onChange={(e) => handleInputOnChange(e, slider.id)}
                            value={slider?.description?.en}
                          />
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              );
            })}
          </Row>
        </Col>

        {/* <Col lg={4} xs={12} className="text-left">
          <button
            type="button"
            className="btn btn-green add_new_section__"
            onClick={() => {
              addSlider();
            }}
          >
            <FormattedMessage id={"addSlider"} />
          </button>
        </Col> */}
      </Row>
    </div>
  );
};

export default SlidersArray;
